// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__QOTQ3","title-left":"Divider_title-left__2kK2R","title-right":"Divider_title-right__yYbY2","small-divider":"Divider_small-divider__9C_a_"};